import React from "react";
import { useBreadCrumbs, useTranslation } from "components/use-hooks";
import BookedSubcontractors from "components/booked-subcontractors";


const EventBookedSubcontractorsSubPage = ({ event }) => {
    const translations = useTranslation();
    useBreadCrumbs([
        { label: translations["BREADCRUMBS.Label_Exhibitions"], path: "/exhibitions" },
        { label: event?.title, path: `/exhibitions/${event?.id}` },
        { label: translations["BOOKED_SUBCONTRACTORS.Title"], path: `/exhibitions/${event?.id}/booked-subcontractors` },
    ]);
    return event?.id ? <BookedSubcontractors key={ event.id } eventID={ event.id } /> : null;
};

export default EventBookedSubcontractorsSubPage;
